
export default {
    namespaced: true,
    state: {
        refreshHistoryListFlag: false, // 刷新历史记录列表，true：刷新，false：不刷新
        isHiddenHistory: false, // 隐藏历史记录，true：隐藏，false：显示
        isHiddenCreateResults: true, // true：隐藏创建结果，false：显示创建结果
        currentSessionId: null, // 当前对话的id，为null时表示新创建的对话还处于默认状态
        anchorTaskId: null, // 锚点任务id
        anchorMaterialId: null, // 锚点物料id
        modifiedTask: null// 中间对话区 & 右侧结果区需要更新内容或状态的物料
    },
    mutations: {
        SET_REFRESH_HISTORY_LIST_FLAG: (state, flag) => {
            state.refreshHistoryListFlag = flag;
        },
        SET_CURRENT_SESSION_ID: (state, sessionId) => {
            state.currentSessionId = sessionId;
        },
        SET_HIDDEN_HISTORY: (state, val) => {
            state.isHiddenHistory = val;
        },
        SET_HIDDEN_CREATE_RESULTS: (state, val) => {
            state.isHiddenCreateResults = val;
        },
        SET_ANCHOR_TASK_ID: (state, taskId) => {
            state.anchorTaskId = taskId;
        },
        SET_ANCHOR_MATERIAL_ID: (state, materialId) => {
            state.anchorMaterialId = materialId;
        },
        SET_MODIFIED_TASK: (state, task) => {
            state.modifiedTask = task;
        }
    },
    actions: {
        setHiddenHistory({commit}, val) {
            commit('SET_HIDDEN_HISTORY', val);
        },
        setHiddenResults({commit}, val) {
            commit('SET_HIDDEN_CREATE_RESULTS', val);
        },
        setModifiedTask({commit}, val) {
            commit('SET_MODIFIED_TASK', val);
        },
        createNewSeeionSucess({commit}, sessionId) {
            commit('SET_CURRENT_SESSION_ID', sessionId);
            commit('SET_REFRESH_HISTORY_LIST_FLAG', true);
        }
    }
};